const endpoints = {
	createUserRequest: '/user_request/createUserRequest',
	acceptRejectUserRequest: '/user_request/acceptRejectUserRequest',
	getUserRequests: '/user_request/getUserRequests',
	getUserRequestById: '/user_request/getUserRequestById',
}
export {endpoints}